import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../../utils/isFlow';
import { Step } from '../../views/Step';
import { Data } from '../../signup-data/DATA';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { getIsMobile } from '../../utils/deviceUtils';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';

const getIsNotMobile = () => !getIsMobile();

const getIsCrmFlow = () => isFlow(Flow.Crm);

const getIsNotAssignedToGosu0001Variant = state => !getIsActiveAndAssignedToVariant(state, ExperimentKeys.GOSU0001, [ExperimentParameterGroup.Variant]);

const getIsNotAssignedToCrmSetupVariant = state => !getIsActiveAndAssignedToVariant(state, ExperimentKeys.GOSU0002, [ExperimentParameterGroup.Variant]);

const getHasSubmittedNoCrmExperience = state => {
  const hasSubmittedNoCrmExperience = getSignupDataValue(state, Data.CrmExperienceLevel) === CrmExperienceOption.None;
  return hasSubmittedNoCrmExperience;
};

const shouldSeeFreeCrmTour = state => {
  return getIsNotMobile() && getIsCrmFlow() && getHasSubmittedNoCrmExperience(state) && getIsNotAssignedToGosu0001Variant(state) && getIsNotAssignedToCrmSetupVariant(state);
};

export const BranchFreeCRMTour = {
  name: 'BranchFreeCRMTour',
  stateCheck: shouldSeeFreeCrmTour,
  rebuildFlow: (flow, state, dispatch) => {
    return dispatch(FlowStateManager.pushNextSteps(Step.FreeCrmDemo));
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};